
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import Icon from 'vux/src/components/icon/index.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'

import {mapGetters} from 'vuex'

export default{
computed: {

headShow() {
return this.$store.getters.headShow;
},
loading() {
return this.$store.getters.loading;
},
footerShow() {
return this.$store.getters.footerShow;
},
pageTitle() {
return "资料完善";
},
},
components: {
Tabbar,
TabbarItem,
XHeader,
Loading,
ViewBox,
Icon
},
data(){
return{




selectedIndex: [0, 0],

columns: [
this.provinces,
[], // 初始城市为空
],






taskname: '',
name:'',
tel:'',
wxid:'',
totalData: [],
uploader: [],
notes: '',
value: '',
value2: '',
showPicker: false,
columns: [],
isPhoneValid:false,
paths:[]
}
},
mounted(){


this.$store.commit('UPDATE_PAGE_TITLE', '任务提交')
this.list = this.initList;

this.doPage()

},
methods:{

onConfirm(value) {
this.value = value.filter(item => !!item).join('/')
this.showPicker = false;
},
subConfirm(){
console.log("进来了")
console.log(this.value)

const regex = /^1(3|4|5|6|7|8|9)\d{9}$/;
this.isPhoneValid = regex.test(this.tel);


if(this.isPhoneValid){
console.log(this.tel.length)
if(this.value === '' || this.name === ''){

this.$message({
message: '字段不允许为空',
type: 'error'
});
}else{
this.xinxitijiao()


}
}else{
this.$message({
message: '手机号错误，请填写11位正确手机号',
type: 'error'
});
}




},
assembleTree(nodes) {
var tree = [];
var nodeMap = {};

nodes.forEach(function (node) {
if(node.parentId===100) {
if(node.deptName !== '交警大队') {
node.children = [{ deptName: ''}];
}

}
nodeMap[node.deptId] = node;
});

nodes.forEach(function (node) {
if (node.parentId === 0) {
tree.push(node);
} else {
var parentNode = nodeMap[node.parentId];
if (!parentNode.children) {
parentNode.children = [];
}
parentNode.children.push(node);
}
});

return tree;
},
doPage() {
this.$axios.get(this.$httpUrl + '/system/dept/list'  ,).then(res => res.data).then(res => {
console.log(res)

let tree = this.assembleTree(res.data);
this.columns = [...tree[0]['children']]












})

},
bumen(){
this.$axios.get(this.$httpUrl + '/system/dept/list').then(res => res.data).then(res => {
console.log(res)


})

},
xinxitijiao(){




this.$axios
.post(this.$httpUrl + "/daren/darennewuser", {
wxid: localStorage.getItem("wxid"),

tel: this.tel,
name: this.name,
unit: '/'+this.value

})
.then((res) => res.data)
.then((res) => {
console.log(res);
console.log(res.code);
console.log(res.msg);
if(res.code === "200"){
alert("新增成功，跳转到登录页")
this.$router.push('/login')
}else if(res.code === "300"){
alert("重复增加")
this.$router.push('/login')
}else{
alert("插入失败，请重新填写信息")
}


});
},
renwutijiao(){

this.$axios
.post(this.$httpUrl + "/daren/personwork", {
id: this.value2,
message: this.notes,
wcfile: this.paths[0]

})
.then((res) => res.data)
.then((res) => {
console.log(res);
if(res.code === 200){
this.$router.push('/memberHome/dashbord')
}


});
},
afterRead(files, detail) {

console.log(files.file);
this.handle(files.file)

},
handle(file) {


var formData = new FormData();
formData.append("file", file); 

this.$axios({
url: this.$httpUrl + "/common/upload2",
headers: {
"Content-Type": "multipart/form-data",
},
method: "post",
data: formData,
})
.then((res) => res.data)
.then((res) => {
console.log(res);
console.log(res.path)
this.$set( this.paths, this.paths.length, res.path);
if (res.code === 200) {
console.log(222)
console.log(res.path)


} else {

}
});





},

}
}



// WEBPACK FOOTER //
// ./src/views/Tupload.vue